<template>
    <Teleport defer to="body">
        <component
            is="script"
            type="application/javascript"
            id="transit-ai-chat-agent-script"
            src="https://ai.alesig.com/app/widgets/transit_ai_chat_agent.js"
            :data-agency="agencyCode" 
        />
    </Teleport>
</template>

<script setup>
import {onBeforeUnmount, onMounted, ref} from "vue";

const props = defineProps({
    agencyCode: {
        required: true,
        type: String,
        validator(value) {
            return value.trim().length > 0;
        }
    },
})

const chatBotElement = ref(null);

// As the third-party Chat Bot is loaded through a script element that updates the DOM outside Vue,
// we have to watch for elements added to the body after the script loads.
const setupMutationObserver = () => {
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.nodeType === 1 && node.shadowRoot && node.shadowRoot.getElementById('agent-chat')) {
                    chatBotElement.value = node;

                    // We don't need to watch for more mutations.
                    observer.disconnect();
                }
            });
        });
    });

    observer.observe(document.body, { childList: true });

    return observer;
}

let observer = null;

onMounted(() => {
    observer = setupMutationObserver();
});

onBeforeUnmount(() => {
    observer?.disconnect();
    chatBotElement.value?.remove();
});
</script>
